export default __webpack_public_path__ + "92d9384bdcb274e74a58843b3dd4fce5.png";